import { useEffect, useState } from 'react';

export default function useScrollSection(sectionIds) {
  const [activeId, setActiveId] = useState(sectionIds[0] || null);

  useEffect(() => {
    if (!sectionIds.length) return undefined;
    if (typeof IntersectionObserver === 'undefined') return undefined;

    const visibility = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          visibility.set(entry.target.id, entry.intersectionRatio);
        });

        let topId = null;
        let topRatio = 0;
        visibility.forEach((ratio, id) => {
          if (ratio > topRatio) {
            topRatio = ratio;
            topId = id;
          }
        });

        if (topId) {
          setActiveId(topId);
        }
      },
      { threshold: [0.1, 0.25, 0.5, 0.75, 1] },
    );

    const elements = sectionIds.map((id) => document.getElementById(id)).filter(Boolean);
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [sectionIds.join('|')]);

  return activeId;
}
